import InmuebleDocTemplate from "../../components/templates/inmuebles/InmuebleDocTemplate";

const InmuebleDoc = () => {
    return <InmuebleDocTemplate/>;
};

export default InmuebleDoc;